/* ============
 * Getters for the account module
 * ============
 *
 * The getters that are available on the
 * account module.
 */

export default {
    byName: (state, name) => state.dharmams.find((dharmam) => dharmam.name === name),
    items: (state) => state.dharmams
};


// WEBPACK FOOTER //
// ./src/store/modules/dharmams/getters.js